import { capitalize, splitByUppercase } from '../../../utils/text.js'
import { CheckboxInput } from '../../CheckboxInput/index.js'

export const BooleanType = ({
  value,
  onChange,
  schemaProp,
  name,
  disabled,
}) => {
  const { title, description, readOnly, default: defaultValue } = schemaProp

  return (
    <CheckboxInput
      value={value !== undefined ? value : defaultValue}
      onChange={(v) => {
        if (onChange) {
          onChange(v, name)
        }
      }}
      label={capitalize(splitByUppercase(title ?? name))}
      description={description}
      disabled={readOnly || disabled}
    />
  )
}
